/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpdateUserContactRequest
 */
export interface UpdateUserContactRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateUserContactRequest
     */
    userContactId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserContactRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserContactRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserContactRequest
     */
    cellPhone: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserContactRequest
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserContactRequest
     */
    sendRoboDials: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserContactRequest
     */
    sendRoboTexts: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserContactRequest
     */
    sendEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserContactRequest
     */
    sendStatements: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserContactRequest
     */
    addressLine1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserContactRequest
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserContactRequest
     */
    addressLine3?: string | null;
}

/**
 * Check if a given object implements the UpdateUserContactRequest interface.
 */
export function instanceOfUpdateUserContactRequest(value: object): value is UpdateUserContactRequest {
    if (!('userContactId' in value) || value['userContactId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('cellPhone' in value) || value['cellPhone'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('sendRoboDials' in value) || value['sendRoboDials'] === undefined) return false;
    if (!('sendRoboTexts' in value) || value['sendRoboTexts'] === undefined) return false;
    if (!('sendEmail' in value) || value['sendEmail'] === undefined) return false;
    if (!('sendStatements' in value) || value['sendStatements'] === undefined) return false;
    return true;
}

export function UpdateUserContactRequestFromJSON(json: any): UpdateUserContactRequest {
    return UpdateUserContactRequestFromJSONTyped(json, false);
}

export function UpdateUserContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userContactId': ApiUserTasksGetPageParameterFromJSON(json['userContactId']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'cellPhone': json['cellPhone'],
        'email': json['email'],
        'sendRoboDials': json['sendRoboDials'],
        'sendRoboTexts': json['sendRoboTexts'],
        'sendEmail': json['sendEmail'],
        'sendStatements': json['sendStatements'],
        'addressLine1': json['addressLine1'] == null ? undefined : json['addressLine1'],
        'addressLine2': json['addressLine2'] == null ? undefined : json['addressLine2'],
        'addressLine3': json['addressLine3'] == null ? undefined : json['addressLine3'],
    };
}

export function UpdateUserContactRequestToJSON(json: any): UpdateUserContactRequest {
    return UpdateUserContactRequestToJSONTyped(json, false);
}

export function UpdateUserContactRequestToJSONTyped(value?: UpdateUserContactRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userContactId': ApiUserTasksGetPageParameterToJSON(value['userContactId']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'cellPhone': value['cellPhone'],
        'email': value['email'],
        'sendRoboDials': value['sendRoboDials'],
        'sendRoboTexts': value['sendRoboTexts'],
        'sendEmail': value['sendEmail'],
        'sendStatements': value['sendStatements'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'addressLine3': value['addressLine3'],
    };
}

